<template>
    <div>

        <div v-if="editUsuario && !dados.id" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <el-form @submit.native.prevent="onSubmitUsuario" v-if="!editUsuario || dados.id" :model="dados" ref="dados" label-position="top">
            <div v-if="!editUsuario || dados.id">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="18" :md="18">
                        <el-form-item label="Nome do Usuário" prop="name" :rules="[$requiredBlur]" key="name">
                            <el-input v-model="dados.name" maxlength="191" v-on:blur="formatData('name')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Situação" prop="situacao" :rules="[$requiredBlur]" key="situacao">
                            <el-select v-model="dados.situacao">
                                <el-option :key="true" label="ATIVO" :value="true"></el-option>
                                <el-option :key="false" label="INATIVO" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <div class="style-form" v-if="editUsuario && !updateUsuario">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <label style="display: block;">Usuário</label>
                            <div style="float: left; width: calc(100% - 55px);" class="style-input readonly">{{ dados.usuario }}</div>
                            <el-button style="float: right; width: 40px; height: 40px;" @click="updateUsuario = true" icon="el-icon-edit" circle></el-button>
                        </el-col>
                    </el-row>
                </div>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="E-mail" prop="email" :rules="[$requiredBlur, $emailBlur]" key="email" class="reset-text-transform">
                            <el-input id="email" v-model="dados.email" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Telefone" prop="telefone" key="telefone">
                            <el-input id="telefone" v-mask="'(##) #########'" v-model="dados.telefone" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10" v-if="!editUsuario || (editUsuario && updateUsuario)">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Usuário" prop="usuario" :rules="[$requiredBlur]" key="usuario">
                            <el-input class="text-transform-none" v-model="dados.usuario" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <div class="style-form" v-if="editUsuario && !updatePassword">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <label style="display: block;">Senha</label>
                            <div style="float: left; width: calc(100% - 55px);" class="style-input readonly">******</div>
                            <el-button style="float: right; width: 40px; height: 40px;" @click="updatePassword = true" icon="el-icon-edit" circle></el-button>
                        </el-col>
                    </el-row>
                </div>

                <el-row :gutter="10" v-if="!editUsuario || (editUsuario && updatePassword)">
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Senha" prop="password" :rules="[$requiredBlur]" key="password">
                            <el-input class="text-transform-none" v-model="dados.password" maxlength="191" type="password"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Confirma Senha" prop="password_confirmation" :rules="[$requiredBlur]" key="password_confirmation">
                            <el-input class="text-transform-none" v-model="dados.password_confirmation" maxlength="191" type="password"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Alterar senha no primeiro login?" prop="cadastrar_senha" :rules="[$requiredBlur]" key="cadastrar_senha">
                            <el-select v-model="dados.cadastrar_senha">
                                <el-option :key="true" label="SIM" :value="true"></el-option>
                                <el-option :key="false" label="NÃO" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Servidor" prop="servidor_id" key="servidor_id">
                            <el-select v-model="dados.servidor_id" placeholder="pesquisar..." filterable clearable remote :remote-method="getServidorByFilter" :loading="loadingServidor">
                                <el-option v-for="item in servidores" :key="item.id" :label="item.nome + ' - ' + item.cpf" :value="item.id"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Tipo de Usuário" prop="tipo" :rules="[$requiredChange]" key="tipo">
                            <el-select v-model="dados.tipo">
                                <el-option v-for="(item, i) in $CONSTANTS.TIPO_USER" :key="i" :label="item" :value="i"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <div class="u-mt-5 u-mb-10">
                    <template v-for="(item, i) in dados.instituicoes">
                        <el-tag v-if="$store.state.instituicoes[item]" class="u-mr-5 u-mt-5" :key="i" type="success">{{ $store.state.instituicoes[item].nome }}</el-tag>
                    </template>
                </div>

                <el-row :gutter="10" v-if="dados.tipo && [0, 1, 2, 3, 9, 12].includes(Number(dados.tipo))">
                    <el-col :xs="24" :sm="24" :md="24">

                        <div class="titulo-list-instituicoes">
                            Instituições Vinculadas ao Usuário
                        </div>

                        <el-input class="search-instituicao" placeholder="pesquisar.." v-model="filtroSearch" maxlength="191"></el-input>

                       <div class="list-instituicoes-usuario">

                           <el-checkbox-group v-model="dados.instituicoes" >
                            <ul>
                                <li v-for="(item, i) in instituicoesFilter" :key="i">
                                    <el-checkbox :label="item.id" class="checkbox-list">{{ item.nome }}</el-checkbox>
                                </li>
                            </ul>
                           </el-checkbox-group>
                       </div>

                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right u-mt-15">
                            <el-button type="primary" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>

    </div>
</template>
<script>

export default {
    props: ['paramId'],
    data: () => ({
        loadingServidor: false,
        servidores: [],
        instituicoes: [],
        instituicoesFilter: [],
        editUsuario: false,
        updateUsuario: false,
        updatePassword: false,
        alert: false,
        filtroSearch: '',
        dados: {
            id: '',
            name: '',
            servidor_id: '',
            situacao: '',
            email: '',
            telefone: '',
            tipo: '',
            usuario: '',
            password: '',
            password_confirmation: '',
            instituicoes: [],
            cadastrar_senha: ''
        }

    }),
    mounted(){

        this.getAllInstituicoes();
    },
    methods:{
        getServidorByFilter(query){

            if (query.length < 4){
            
                this.servidores = [];
                return false;
            }

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/servidor/searchByNome`, {query: query}, this.$store.getters.getHeaderAuth).then(response => {
            
                this.servidores = JSON.parse(JSON.stringify(response.data));
            
            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getAllInstituicoes(){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAllStatus`, this.$store.getters.getHeaderAuth).then(response => {

                this.instituicoes = JSON.parse(JSON.stringify(response.data));
                this.instituicoesFilter = this.instituicoes;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getUsuarioById(id){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/usuario/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {

                if(response.data.servidor){
                    this.servidores.push(response.data.servidor);
                }

                this.dados = JSON.parse(JSON.stringify(response.data));

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        onSubmitUsuario(){

            this.$refs.dados.validate((valid) =>{ if(valid){

                window.eventBus.$emit('loading', true);

                if(this.editUsuario){

                    let dados = {

                        id: this.dados.id,
                        name: this.dados.name,
                        tipo: this.dados.tipo,
                        usuario: ((this.updateUsuario) ? this.dados.usuario : ''),
                        password: ((this.updatePassword) ? this.dados.password : ''),
                        password_confirmation: ((this.updatePassword) ? this.dados.password_confirmation : ''),
                        instituicoes: this.dados.instituicoes,
                        situacao: this.dados.situacao,
                        cadastrar_senha: this.dados.cadastrar_senha,
                        email: this.dados.email,
                        telefone: this.dados.telefone,
                        servidor_id: this.dados.servidor_id
                    };

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/usuario/update/` + dados.id, dados, this.$store.getters.getHeaderAuth).then(response => {

                        if(typeof response.data.throw !== 'undefined'){

                            window.eventBus.$emit('alert', {msg: response.data.throw.msg, type: response.data.throw.type});

                        }else{

                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                            this.$emit('onSubmitUsuario');
                        }

                        window.eventBus.$emit('loading', false);

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }else{

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/usuario/store`, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                        if(typeof response.data.throw !== 'undefined'){

                            window.eventBus.$emit('alert', {msg: response.data.throw.msg, type: response.data.throw.type});

                        }else{

                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                            this.$emit('onSubmitUsuario');
                        }

                        window.eventBus.$emit('loading', false);

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA

            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.$removerAcentos(this.dados[field]);
        },
        resetFormUsuario(){

            this.dados = { id: '', nome: '', descricao: '', ativa: '', emDestaque: null };
            this.$refs.dados.clearValidate();
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {

                if(value){

                    this.getUsuarioById(value);
                    this.editUsuario = true;
                }
            }
        },
        filtroSearch: {
            handler (value) {

                let res = this.instituicoes.filter(item => {

                    return item.nome.toLowerCase()
                    .indexOf(value.toLowerCase()) > -1;

                });

                this.instituicoesFilter = res;
            }
        },
        'dados.tipo': function(newVal, oldVal){

            if(newVal > 3 && newVal != 9 && newVal != 12){

                this.dados.instituicoes = [];
            }
        }

    }
}
</script>
<style>

    .search-instituicao .el-input__inner{
        border-radius: initial;
    }

    .titulo-list-instituicoes {
        background-color: #ccc; padding: 5px 10px;
    }

    .list-instituicoes-usuario{
        margin: 10px 0px;
    }

    .list-instituicoes-usuario .checkbox-list{
        margin-left: 20px;
    }

    .list-instituicoes-usuario ul {
        padding: 0;
        height: 700px;
        overflow: auto;
    }

    .list-instituicoes-usuario li {
        padding: 5px 0;
        border-bottom: 1px solid #ccc;
    }

    .list-instituicoes-usuario{
        border: 1px solid #ccc;
    }

</style>